module.exports = "**Where is my data stored?**\n\nIf your workspace is not synced, your files are stored inside your browser and nowhere else.\n\nWe recommend syncing your workspace to make sure files won't be lost in case your browser data is cleared. Self-hosted CouchDB or GitLab backends are well suited for privacy.\n\n**Can StackEdit access my data without telling me?**\n\nStackEdit is a browser-based application. The access tokens issued by Google, Dropbox, GitHub... are stored in your browser and are not sent to any kind of backend or 3^rd^ party so your data won't be accessed by anyone.\n"


//////////////////
// WEBPACK FOOTER
// ./src/data/faq.md
// module id = 2203
// module chunks = 1